module.exports = __webpack_public_path__ + "static/media/30.0392bec3.jpg";